import { useDynamicData, currentLanguage } from '@avensia/excite';
import { styled } from '@glitz/react';
import { createFieldSizeDecorator, FieldSize } from 'webapp/components/field-size';
import { Theme } from 'webapp/theme';
import Select from 'nordicnest/shared/fields/Select';
import { getCurrentFlag } from 'nordicnest/shared/icons';
import * as React from 'react';

export function useLanguageOptions() {
  const [languages] = useDynamicData<NordicNest.Api.LanguagesApiModel>();

  const options: NordicNest.Api.SelectOptionApiModel[] =
    languages?.list.map(l => ({
      value: l.languageCode,
      text: l.language,
    })) || [];

  const onSelectLanguage = React.useCallback(
    (value?: string) => {
      const language = languages?.list.find(l => l.languageCode === value);
      if (language?.url) {
        if(__DEV__ && language.url.split("/").length > 3) {
          const url = `${language.url.substring(0, language.url.lastIndexOf("/"))}:${location.port}${language.url.substring(language.url.lastIndexOf("/"))}`;
          location.href = url;
        } else {
          const port = __DEV__ ? ':' + location.port : '';
          location.href = language.url + port;
        }
      }
    },
    [languages?.list],
  );
  return { onSelectLanguage, options };
}

function optionTransform(option: NordicNest.Api.SelectOptionApiModel) {
  const Flag = getCurrentFlag(option.value);

  return (
    <Country>
      <Flag css={flagDecorator} />
      <Text>{option.text}</Text>
    </Country>
  );
}
export const CountrySelector = styled(() => {
  const { onSelectLanguage, options } = useLanguageOptions();

  return (
    <Dropdown
      size={FieldSize.Small}
      as={Theme.White}
      onChangeOption={onSelectLanguage}
      value={currentLanguage()}
      options={options}
      selectedValueDecorator={currentSelectValueDecorator}
      alignOptions={'left'}
      selectedTransform={optionTransform}
      optionTransform={optionTransform}
      maxHeight={'auto'}
    />
  );
});

const flagDecorator = styled({
  fontSize: t => t.fontSize.xxs,
});

const currentSelectValueDecorator = styled(createFieldSizeDecorator(FieldSize.XSmall), {
  padding: { x: 0 },
  fontWeight: 'bold',
});

const Dropdown = styled(Select, {
  textTransform: 'capitalize',
  fontSize: t => t.fontSize.xs,
  height: '100%',
});

const Country = styled.div({
  display: 'flex',
  alignItems: 'center',
});

const Text = styled.span({
  marginLeft: t => t.spacing.xs,
});
